// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2Xxra","buttons":"SendReceipts_buttons__1l4Sn","email":"SendReceipts_email__3o9wx","bookApptTitle":"SendReceipts_bookApptTitle__1Ofqc"};